import { render, staticRenderFns } from "./NotificationBubble.vue?vue&type=template&id=7615a7be"
import script from "./NotificationBubble.vue?vue&type=script&lang=js"
export * from "./NotificationBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports